import { useLostChangesModal } from '../screens/order/lost-changes-modal';
import { useOrderModal } from '../screens/order/order-modal';

function useProductSelectionWorkflow() {
  const { prepareOrderModal, showOrderModal } = useOrderModal({});
  const { showLostChangesModal } = useLostChangesModal();

  async function prepare({ category, item }) {
    await prepareOrderModal({ category, item });
  }

  async function show({ prepareOnPreConfirm } = {}) {
    const result = await showOrderModal({ prepareOnPreConfirm });

    if (result.hasLostChanges) {
      await showLostChangesModal();
    }

    return result;
  }

  return {
    prepareProductSelectionWorkflow: prepare,
    showProductSelectionWorkflow: show,
  };
}

export { useProductSelectionWorkflow };
